export default [

    {
        name: 'Dashboard',
        icon: 'ti-file',
        collapsed: true,
        children: [{
                name: 'Dashboard',
                icon: 'user',
                path: '/dashboard/avanti'
            },
            {
                name: 'Gestión de autorizaciones',
                icon: 'user',
                path: '/gestion-ordenes'
            }
        ]

    },

    {
        name: 'Reportes',
        icon: 'ti-folder',
        collapsed: true,
        children: [{
                name: 'Pacientes',
                icon: 'user',
                path: '/reportes/pacientes'
            },
            {
                name: 'Ordenes Medicas',
                icon: 'user',
                path: '/reportes/ordenes'
            },
            {
                name: 'Reporte Maestro',
                icon: 'user',
                path: '/reportes/maestro'
            },
            {

                name: 'Reporte de autorizaciones',
                icon: 'user',
                path: '/reportes/autorizaciones'
            },
            {

                name: 'Informes de paciente',
                icon: 'user',
                path: '/reportes/informeEvolucion'
            }

        ]
    },

    {
        name: 'Admisiones',
        icon: 'ti-user',
        collapsed: true,
        children: [{
                name: 'Ingreso de pacientes',
                icon: 'user',
                path: '/admisiones/ingreso'
            },
            {
                name: 'Pacientes Registrados',
                icon: 'user',
                path: '/admisiones/pacientes'
            },
            {
                name: 'Ingreso de autorizaciones',
                icon: 'user',
                path: '/admisiones/servicios'
            }
        ]
    },

    {
        name: 'Historia Clínica',
        icon: 'ti-folder',
        collapsed: true,
        children: [{
                name: 'Historia Clínica',
                path: '/historiaClinica/historia'
            },

        ]
    }, {
        name: 'Mantenimiento',
        icon: 'ti-settings',
        collapsed: true,
        children: [{
                name: 'Eps',
                path: '/mantenimiento/mantenimientoEps'
            },
            {
                name: 'Patologías',
                path: '/mantenimiento/mantenimientoPatologias'
            },
            {
                name: 'Motivo de Consulta',
                path: '/mantenimiento/mantenimientoMC'
            },
            {
                name: 'Material de apoyo',
                path: '/mantenimiento/mantenimientoMat'
            },
            {
                name: 'Estrategías terapeuticas',
                path: '/mantenimiento/mantenimientoEs'
            },

        ]
    },

    {
        name: 'Acceso',
        icon: 'ti-shift-right',
        collapsed: true,
        children: [{
                name: 'Usuarios',
                path: '/acceso/usuario'
            },
            {
                name: 'Roles',
                path: '/acceso/roles'
            },


        ]
    },

    {
        name: 'Plan de intervención',
        icon: 'ti-agenda',
        collapsed: true,
        children: [{
                name: 'Evoluciones',
                path: '/diarioCampo/evoluciones'
            },
            {
                name: 'Objetivos y Logros',
                path: '/diarioCampo/objetivos-y-logros'
            },
            {
                name: 'Objetivos y Logros en Familia',
                path: '/diarioCampo/objetivos-logros-familia'
            },


        ]
    },

    {
        name: 'Programación',
        icon: 'ti-alarm-clock',
        //if: localStorage.getItem('rol') == 2,
        collapsed: true,
        children: [{
                name: 'Programación de citas',
                path: '/programacion/programacion-citas'
            },
            // {
            //     name: 'Disponibilidad pacientes',
            //     path: '/programacion/disponibilidad'
            // },
            // {
            //     name: 'Disponibilidad terapeutas',
            //     path: '/programacion/horariosProfesionales'
            // },
            // {
            //     name: 'Programación  Automatica',
            //     path: '/programacion/automatico'
            // }



        ]
    },

    // {
    //     name: 'Exámenes',
    //     icon: 'ti-alarm-clock',
    //     collapsed: true,
    //     children: [{
    //             name: 'Psicologia de Niños',
    //             path: '/examenes/psicologia-ninos'
    //         },
    //         {
    //             name: 'Fonoaudiologia función oral',
    //             path: '/examenes/fonoaudiologia'
    //         },
    //         {
    //             name: 'Fonoaudiologia Lenguaje',
    //             path: '/examenes/fonolenguaje'
    //         },
    //         {
    //             name: 'Terapía ocupacional - entrevista',
    //             path: '/examenes/terapiaocupacional'
    //         }



    //     ]
    // }


]


// WEBPACK FOOTER //
// ./src/sidebarLinks.js